import { datadogRum } from "@datadog/browser-rum";

// Datadog Real User Monitoring (RUM).
// env/version can be overridden at build time via CRA env vars
// (REACT_APP_DD_ENV / REACT_APP_DD_VERSION); otherwise sensible defaults apply.
datadogRum.init({
  applicationId: "db06b316-aae3-47b3-b4c2-71109f0e3567",
  clientToken: "pubbccf1603d88111f57cd13d22c9a871a3",
  site: "us5.datadoghq.com",
  service: "saucedemo",
  env: process.env.REACT_APP_DD_ENV || "prod",
  version: process.env.REACT_APP_DD_VERSION || "3.0.0",
  sessionSampleRate: 100, // capture 100% of sessions
  sessionReplaySampleRate: 20, // capture 20% of sessions with replay
  trackResources: true, // Enable Resource tracking
  trackUserInteractions: true, // Enable Action tracking
  trackLongTasks: true, // Enable Long Tasks tracking

  // ----- Recommended Options -----
  // allowedTracingUrls: ['<BACKEND_URL>'], // Enable distributed tracing
  defaultPrivacyLevel: "mask-user-input", // 'mask-user-input' | 'allow' | 'mask'
});
